/*
  reportApi.js
  Lightweight helpers for the Staff Report Management API
  (mirrors patterns used in src/constants/api.js)
*/
import axios from 'axios';
import urlconfig from '../_config';

// Use bearerConfig to call the report server; this mirrors other report helpers in api.js
const bearerConfig = () => ({
  headers: {
    'Content-Type': 'application/json',
    // use the same auth token key used across the app
    ...(localStorage.getItem('token') ? { Authorization: `Bearer ${localStorage.getItem('token')}` } : {}),
  },
});

// 1) Pre-generate a report (POST /staff/pre-generate-report)
export const PREGENERATE_STAFF_REPORT = (payload) =>
  axios.post(`${urlconfig.reportApi}/report/v2/staff/pre-generate-report`, payload, bearerConfig());

// 2) Check cache status (GET /staff/cache-status?organization_id=...&audit_type_id=...)
export const GET_STAFF_CACHE_STATUS = (payload) =>
  axios.get(`${urlconfig.reportApi}/report/v2/staff/cache-status${payload ? `?${payload}` : ''}`, bearerConfig());

// 3) List cached reports (GET /staff/list-cached-reports)
// Accepts pagination and filtering via query string payload
export const LIST_STAFF_CACHED_REPORTS = (payload) =>
  axios.get(`${urlconfig.reportApi}/report/v2/staff/list-cached-reports${payload ? `?${payload}` : ''}`, bearerConfig());

// 4) Invalidate cache (DELETE /staff/invalidate-cache?organization_id=...&audit_type_id=...)
export const INVALIDATE_STAFF_CACHE = (payload) =>
  axios.delete(`${urlconfig.reportApi}/report/v2/staff/invalidate-cache${payload ? `?${payload}` : ''}`, bearerConfig());

// 5) Get access logs for a report (GET /staff/access-logs/{report_id})
export const GET_STAFF_ACCESS_LOGS = ({ id, query }) =>
  axios.get(`${urlconfig.reportApi}/report/v2/staff/access-logs/${id}${query ? `?${query}` : ''}`, bearerConfig());

const reportApi = {
  PREGENERATE_STAFF_REPORT,
  GET_STAFF_CACHE_STATUS,
  LIST_STAFF_CACHED_REPORTS,
  INVALIDATE_STAFF_CACHE,
  GET_STAFF_ACCESS_LOGS,
};

export default reportApi;
